<script lang="ts" setup>
import { useRouter,useRoute } from 'vue-router/composables'
import { onMounted, ref } from 'vue'
import { useLoadingStore, useToastStore, useUserStore } from '@/stores'
import { isMobile } from '@/utils'
import { api } from '@/api'
import { $formatErrorMessage, $isLogin, $setToken } from '@/helpers'

const { $showLoading, $hideLoading } = useLoadingStore()
const { $toast } = useToastStore()
const userStore = useUserStore()

const router = useRouter()
const route = useRoute()
const redirectUrl = ref(route.query.r as string || 'home');

const form = ref({
  phone: '',
  code: '',
})

onMounted(() => {
  if ($isLogin())
    router.replace({ name: 'home' })
})

const countdown = ref(0)
async function onSendCode() {
  if (!isMobile(form.value.phone)) {
    $toast('请输入正确的手机号码')
    return
  }

  try {
    $showLoading()
    await api.post('/escort/user/send_phone_code', {
      phone: form.value.phone,
    })
    $toast('短信发送成功')
    countdown.value = 60
    startCountdown()
  }
  catch (error: any) {
    $toast($formatErrorMessage(error))
  }
  finally {
    $hideLoading()
  }
}
function startCountdown() {
  if (countdown.value === 0)
    return
  setTimeout(() => {
    countdown.value = countdown.value - 1
    startCountdown()
  }, 1000)
}

async function onLogin() {
  try {
    $showLoading()
    const { data } = await api.post('/escort/user/login', {
      phone: form.value.phone,
      code: form.value.code,
    })
    $setToken(data.jwt)
    // 拉取用户信息，检查 escort_name 是否为手机号
    await userStore.init({ force: true })
    if (isMobile(userStore.$state.name)) {
      router.replace({ name: 'collect-name', query: { r: redirectUrl.value } })
      return
    }
    if (redirectUrl.value !== 'home'){
      redirectUrl.value = redirectUrl.value.replace('%2F', '')
    }
    if (!redirectUrl.value) {
      redirectUrl.value = 'home'
    }
    router.replace({ name: redirectUrl.value })
  }
  catch (error: any) {
    $toast($formatErrorMessage(error))
  }
  finally {
    $hideLoading()
  }
}
</script>

<template>
  <div class="min-h-screen px-5 py-10 bg-gradient-to-br from-blue-400 to-blue-100">
    <p class="py-20 text-2xl font-bold text-center">
      启泰元康健康管理陪诊系统
    </p>

    <div class="mt-4 rounded-full overflow-hidden shadow">
      <input v-model="form.phone" type="text" maxlength="11" class="w-full h-10 px-4" placeholder="手机号码">
    </div>
    <div class="mt-4 rounded-full overflow-hidden shadow relative">
      <input v-model="form.code" type="text" maxlength="6" class="w-full h-10 px-4" placeholder="验证码">
      <p v-if="countdown === 0" class="text-sm text-#467FF2 lh-10 px-4 absolute right-0 top-0" @click="onSendCode">
        发送验证码
      </p>
      <p v-else class="text-sm text-#999 lh-10 px-4 absolute right-0 top-0">
        {{ countdown }}秒后重新发送
      </p>
    </div>

    <button
      class="mt-4 w-full h-10 lh-10 text-white bg-#467FF2 rounded-full"
      @click="onLogin"
    >
      立即登录
    </button>
  </div>
</template>
